import React, { useState } from 'react';
import { BaseManageModal } from './BaseManageModal';

/**
 * EditAssignedModal - Modal for editing VMs that already have a group or app assigned
 * Includes unassign checkbox option
 */
export const EditAssignedModal = ({
    open,
    onCancel,
    onApply,
    moveGroups = [],
    applications = [],
    users = [],
    selectedRowKeys = [],
}) => {
    const [unassign, setUnassign] = useState(false);
    const [moveGroupDisabled, setMoveGroupDisabled] = useState(false);

    const handleApplicationChange = (applicationId, form) => {
        if (applicationId) {
            // Find the selected application
            const selectedApp = applications.find((app) => app.value === applicationId);

            if (selectedApp && selectedApp.move_group_ids && selectedApp.move_group_ids.length > 0) {
                // Auto-fill the move group field with the app's move group
                const moveGroupId = selectedApp.move_group_ids[0];
                form.setFieldsValue({ moveGroup: moveGroupId });
                setMoveGroupDisabled(true);
            } else {
                // App has no move group, allow selection
                setMoveGroupDisabled(false);
            }
        } else {
            // No app selected, enable move group field
            setMoveGroupDisabled(false);
        }
    };

    const handleApply = (values, form) => {
        // Transform values to match the expected format
        const payload = {
            moveGroup: unassign ? null : values.moveGroup,
            application: unassign ? null : values.application,
            resource: values.resource,
            date: values.date,
            unassign,
        };
        onApply?.(payload);
        form.resetFields();
        setUnassign(false);
        setMoveGroupDisabled(false);
    };

    const handleCancel = (form) => {
        form?.resetFields();
        setUnassign(false);
        setMoveGroupDisabled(false);
        onCancel?.();
    };

    const handleUnassignChange = (e, form) => {
        setUnassign(e.target.checked);
        if (e.target.checked) {
            form.setFieldsValue({
                moveGroup: undefined,
                application: undefined,
                resource: undefined,
                date: null,
            });
            setMoveGroupDisabled(false);
        }
    };

    return (
        <BaseManageModal
            open={open}
            onCancel={() => handleCancel()}
            onApply={handleApply}
            title="Manage Source Assignment"
            description={`Assign ${selectedRowKeys.length > 0 ? `${selectedRowKeys.length} selected` : ''} source(s) to Move Group or Application`}
            selectedRowKeys={selectedRowKeys}
            showMoveGroupField
            showApplicationField
            showNote
            showRemoveAssignmentCheckbox
            noteText="Note: A VM can only belong to one Move Group and one Application at a time."
            removeAssignmentText="Unassign (Clear all)"
            removeAssignmentDescription="Remove from any current groups or applications."
            moveGroups={moveGroups}
            applications={applications}
            onRemoveAssignmentChange={handleUnassignChange}
            removeAssignment={unassign}
            onApplicationChange={handleApplicationChange}
            moveGroupDisabled={moveGroupDisabled}
        />
    );
};
